// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/fca6ceb2/" + chunkId + "." + __webpack_require__.h() + ".vfca6ceb2.js";
};